import { Web3Provider } from "@ethersproject/providers";
import { walletConnectV2 } from "../connectors/walletConnectV2";
// import { walletConnectV3 } from "../connectors/tomiPayV2";/
import { metaMask } from "../connectors/metaMask"
import { coinbaseWallet } from "../connectors/coinbaseWallet";

const ConnectorNames = {
    Injected: "injected",
    WalletConnect: "walletconnect",
    CoinBase: "coinbase"
    // WalletConnect1:"walletconnect1"
}

export const connectorsByName = {
    [ConnectorNames.Injected]: metaMask,
    [ConnectorNames.WalletConnect]: walletConnectV2,
    [ConnectorNames.CoinBase]: coinbaseWallet,
    // [ConnectorNames.WalletConnect1]: walletConnectV3
}

export const getLibraryForSign = (provider) => {
    const library = new Web3Provider(provider);
    return library
}

export const getLibrary = (provider) => {
    return provider
}